var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
const Wrapper = styled.div `
    margin-bottom: 20px;
    width: ${(props) => {
    if (props.maxWidth) {
        return "350px";
    }
    return "100%";
}};
    max-width: 100%;

    &:last-child {
        margin: 0;
    }
`;
const InputWrapper = (_a) => {
    var { className, children, maxWidth } = _a, restProps = __rest(_a, ["className", "children", "maxWidth"]);
    return (React.createElement(Wrapper, Object.assign({ maxWidth: maxWidth, className: className }, restProps), children));
};
export default InputWrapper;
